// extracted by mini-css-extract-plugin
export default {"map_container":"IpMap_map_container__5WihN","map":"IpMap_map__0qrxL","info_list":"IpMap_info_list__CoOuR"};